export default __webpack_public_path__ + "static/media/benifit-three-icon.c32897ce.svg";